module.exports = __webpack_public_path__ + "fonts/Linearicons-Free.2f3e9f80.ttf";